/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { EverqueueActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        everqueue: state.everqueue
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getEverqueue: (id) => {
            dispatch(EverqueueActions.fetchEverqueue(id));
        },
        deleteEverqueue: (id, items, sledgehammer) => {
            dispatch(EverqueueActions.deleteEverqueue(id, items, sledgehammer));
        },
        updateEverqueue: (id, item) => {
            dispatch(EverqueueActions.updateEverqueue(id, item));
        }
	};
}

export default function EverqueueProvider(Component) {

    class EverqueueProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    EverqueueProvider.displayName = "EverqueueProvider";

    return connect(mapStateToProps, mapDispatchToProps)(EverqueueProvider);
};
